import React from 'react';
import { Info } from '@mui/icons-material';
import { Stack, styled, Typography } from '@mui/material';

interface AssessmentsQuestionErrorInfoProps {
  showError: boolean;
}

const ErrorInfoContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const AssessmentsQuestionErrorInfo: React.FC<AssessmentsQuestionErrorInfoProps> = ({
  showError,
}) => {
  if (!showError) return null;

  return (
    <ErrorInfoContainer direction="row" spacing={1.5}>
      <Info color="error" fontSize="medium" />
      <Typography variant="body1" color="error.main">
        This question type is not supported. Remove from configuration.
      </Typography>
    </ErrorInfoContainer>
  );
};
